import { styled } from '@mui/material';
import ModalFooter from 'components/system/Modal/ModalFooter';

export const StyledFooter = styled(ModalFooter)(({ theme }) => ({
  marginTop: theme.spacing(7),
}));
